import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { hinhThucApi } from "../../../api/mien-giam/hinhThucApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IDmDoiTuongMienGiam } from "../../../model/respone/mien-giam/IDmDoiTuongMienGiam";
import {
  eHinhThucActionIds,
  IHinhThucActionTypes,
} from "../../action-types/mien-giam/IHinhThucActions";
import { rootActions } from "../../actions/rootActions";

export function* hinhThucSaga(): any {
  yield takeLatest(eHinhThucActionIds.LOAD_START, loadWorker);
  yield takeEvery(eHinhThucActionIds.SAVE_START, saveWorker);
  yield takeEvery(eHinhThucActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(hinhThucApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.mienGiam.hinhThuc.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.mienGiam.hinhThuc.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IHinhThucActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IDmDoiTuongMienGiam;
  if (payload.id_dt > 0) {
    res = yield call(hinhThucApi.Update, payload);
  } else {
    res = yield call(hinhThucApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.mienGiam.hinhThuc.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.mienGiam.hinhThuc.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IHinhThucActionTypes): any {
  const res: IBaseRespone = yield call(
    hinhThucApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.mienGiam.hinhThuc.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mienGiam.hinhThuc.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
